import { axiosInstance } from '@/lib/axios';

/**
 * Report Problem Service
 * Handles problem report submission API calls
 */

export interface ProblemReportFormData {
  name: string;
  email: string;
  subject: string;
  description: string;
  honeypot?: string; // Anti-spam honeypot field
}

export interface ProblemReportSubmissionResponse {
  message: string;
}

/**
 * Submit problem report
 * Public endpoint - no authentication required
 */
export const submitProblemReport = async (
  formData: ProblemReportFormData
): Promise<ProblemReportSubmissionResponse> => {
  const response = await axiosInstance.post<ProblemReportSubmissionResponse>(
    '/report-problem/submit',
    formData
  );

  return response.data;
};
